// removed by extract-text-webpack-plugin
module.exports = {"appDrawer":"Sidedrawer__appDrawer__3ks7x","appNavLinkActive":"Sidedrawer__appNavLinkActive__17oGa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Sidedrawer/Sidedrawer.css
// module id = 283
// module chunks = 0